export default "__VITE_PUBLIC_ASSET__b05dfec6__"